import React from 'react'
import PropTypes from 'prop-types'

import { BaseConfirmationDialog } from 'components'
import * as service from 'service'

const ChangeStatusSubCategoryDialog = ({
  open,
  setOpen,
  subCategory,
  categoryId,
  onRefresh,
}) => {
  const isActive = subCategory.active !== false
  const actionText = isActive ? 'Inativar' : 'Ativar'
  const newStatus = !isActive

  const handleConfirmAction = async () => {
    try {
      await service.dponet.complaintSubCategories.update({
        categoryId,
        subCategoryId: subCategory.id,
        active: newStatus,
      })
      onRefresh()
      setOpen(false)
    } catch (error) {
      console.error(`Erro ao ${actionText.toLowerCase()} subcategoria:`, error)
    }
  }

  return (
    <BaseConfirmationDialog
      open={open}
      setOpen={setOpen}
      title={`${actionText} Subcategoria`}
      text={`Tem certeza que deseja ${actionText.toLowerCase()} a opção "${
        subCategory?.name
      }"?`}
      actionButtonText={actionText}
      actionButton={handleConfirmAction}
      variant={isActive ? 'warning' : 'blueConfirmation'}
    />
  )
}

ChangeStatusSubCategoryDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
  subCategory: PropTypes.object.isRequired,
  categoryId: PropTypes.number.isRequired,
  onRefresh: PropTypes.func.isRequired,
}

export default ChangeStatusSubCategoryDialog
